import React, { useState } from 'react';
import { ActivityTimelineListItem } from './timelineListItems/ActivityTimelineListItem';
import { ConsentTimelineListItem } from './timelineListItems/ConsentTimelineListItem';
import { CgmStatusTimelineListItem } from './timelineListItems/CgmStatusTimelineListItem';
import { CarePlanTimelineListItem } from './timelineListItems/CarePlanTimelineListItem';
import { TaskTimelineListItem } from './timelineListItems/TaskTimelineListItem';
import { DemographicsTimelineListItem } from './timelineListItems/DemographicsTimelineListItem';
import { AdminTimelineListItem } from './timelineListItems/AdminTimelineListItem';
import { BillingTimelineListItem } from './timelineListItems/BillingTimelineListItem';
import { FollowUpTimelineListItem } from './timelineListItems/FollowUpTimelineListItem';
import { AttachMoneyOutlined, CachedOutlined, DescriptionOutlined, FactCheckOutlined, NoteAddOutlined, NoteAltOutlined, PersonOutlined, StayCurrentPortraitOutlined } from '@mui/icons-material';
function getTimelineIcon(activityType) {
    switch (activityType) {
        case 'activity': return NoteAddOutlined;
        case 'consent': return NoteAltOutlined;
        case 'cgmStatus': return CachedOutlined;
        case 'carePlan': return DescriptionOutlined;
        case 'task': return FactCheckOutlined;
        case 'demographics': return PersonOutlined;
        case 'admin': return StayCurrentPortraitOutlined;
        case 'billing': return AttachMoneyOutlined;
        case 'follow-up': return FactCheckOutlined;
        default: return NoteAddOutlined;
    }
}
function getIconBgColor(activityType) {
    switch (activityType) {
        case 'activity': return '#2C78EB26';
        case 'consent': return '#018FB726';
        case 'cgmStatus': return '#CEFAF1';
        case 'carePlan': return '#DDFCE8';
        case 'task': return '#EDE9FD';
        case 'demographics': return '#FBE7F2';
        case 'admin': return '#EBEBEB';
        case 'billing': return '#ECFCCF';
        case 'follow-up': return '#EDE9FD';
        default: return '#2C78EB26';
    }
}
function getIconColor(activityType) {
    switch (activityType) {
        case 'activity': return '#2C78EB';
        case 'consent': return '#018FB7';
        case 'cgmStatus': return '#1E9388';
        case 'carePlan': return '#25A253';
        case 'task': return '#7B3BE6';
        case 'demographics': return '#D82F75';
        case 'admin': return '#757575';
        case 'billing': return '#4F7C24';
        case 'follow-up': return '#7B3BE6';
        default: return '#2C78EB';
    }
}
function renderListItem(activity) {
    switch (activity.activityType) {
        case 'activity':
            return React.createElement(ActivityTimelineListItem, { timelineActivity: activity });
        case 'consent':
            return React.createElement(ConsentTimelineListItem, { timelineActivity: activity });
        case 'cgmStatus':
            return React.createElement(CgmStatusTimelineListItem, { timelineActivity: activity });
        case 'carePlan':
            return React.createElement(CarePlanTimelineListItem, { timelineActivity: activity });
        case 'task':
            return React.createElement(TaskTimelineListItem, { timelineActivity: activity });
        case 'demographics':
            return React.createElement(DemographicsTimelineListItem, { timelineActivity: activity });
        case 'admin':
            return React.createElement(AdminTimelineListItem, { timelineActivity: activity });
        case 'billing':
            return React.createElement(BillingTimelineListItem, { timelineActivity: activity });
        case 'follow-up':
            return React.createElement(FollowUpTimelineListItem, { timelineActivity: activity });
        default:
            return React.createElement("div", null, "Error...");
    }
}
const filterOptions = [
    { label: 'All', value: 'All' },
    { label: 'Activities', value: 'activity' },
    { label: 'Admin', value: 'admin' },
    { label: 'Billing', value: 'billing' },
    { label: 'Care Plan', value: 'carePlan' },
    { label: 'CGM Status', value: 'cgmStatus' },
    { label: 'Consent', value: 'consent' },
    { label: 'Demographics', value: 'demographics' },
    { label: 'Tasks & Follow-Ups', value: 'task,follow-up' },
];
export const PatientTimeline = (props) => {
    const { activites } = props;
    const [activeFilter, setActiveFilter] = useState('All');
    const sortedActivities = [...activites].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    const filteredActivities = activeFilter === 'All'
        ? sortedActivities
        : sortedActivities.filter(a => activeFilter.split(',').includes(a.activityType));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "flex gap-2 flex-wrap p-4 bg-white rounded m-4" }, filterOptions.map(option => (React.createElement("button", { key: option.value, onClick: () => {
                console.log('clicked', option.value);
                setActiveFilter(option.value);
            }, style: {
                padding: '0px 12px',
                borderRadius: '20px',
                backgroundColor: activeFilter === option.value ? '#2C78EB' : '#00000014',
                color: activeFilter === option.value ? 'white' : '#000000DE',
                cursor: 'pointer',
                fontFamily: 'Barlow',
                fontSize: '14px',
                fontWeight: 600,
                height: '25px'
            } }, option.label)))),
        filteredActivities.map((activity, index) => {
            const isLast = index === filteredActivities.length - 1;
            const Icon = getTimelineIcon(activity.activityType); // your icon mapping function
            return (React.createElement("div", { key: `${activity.activityType}-${activity.id}-${index}`, className: "flex", style: { marginLeft: '16px' } },
                React.createElement("div", { className: "flex flex-col items-center", style: { width: '40px', flexShrink: 0 } },
                    React.createElement("div", { style: {
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            backgroundColor: getIconBgColor(activity.activityType),
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '16px',
                        } },
                        React.createElement(Icon, { style: { color: getIconColor(activity.activityType), fontSize: 20 } })),
                    !isLast && (React.createElement("div", { style: {
                            width: '2px',
                            flexGrow: 1,
                            backgroundColor: '#E0E0E0',
                        } }))),
                React.createElement("div", { className: "flex-grow" }, renderListItem(activity))));
        })));
};
